import type React from 'react';

import { FormField, Heading, Label, Paragraph } from '@zillow/constellation-10';

import type { Section } from '../../../models';
import { BASE_RENT } from '../../../constants';
import CurrencyInput from '../../Widgets/CurrencyInput';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function RentalProtectionBaseRent({ section, setSectionValues }: Props) {
  function onMonthlyBaseRentChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    const { value } = event.currentTarget;

    setSectionValues({
      [BASE_RENT.FIELD_NAME.AMOUNT]: value,
    });
  }

  return (
    <>
      <Heading level={3} textStyle="responsive.heading-xs" css={{ marginBottom: 'layout.tight' }}>
        Is this the rent amount in the lease you uploaded?
      </Heading>
      <Paragraph css={{ marginBottom: 'layout.tight' }}>
        <strong>Confirm that the amount shown matches the amount in your lease</strong>
      </Paragraph>
      <Paragraph css={{ marginBottom: 'layout.tight' }}>
        The monthly rent amount shouldn’t include any monthly fees, like parking. You’ll be able to add fees when you
        set up payments. If you want the rent amount to be different than the one in the lease, we recommend uploading a
        new lease with the correction.
      </Paragraph>
      <FormField
        required
        label={<Label>Monthly base rent</Label>}
        control={
          <CurrencyInput
            value={section.getFieldValue(BASE_RENT.FIELD_NAME.AMOUNT)}
            onChange={onMonthlyBaseRentChange}
            onBlur={onMonthlyBaseRentChange}
          />
        }
      />
    </>
  );
}

export default RentalProtectionBaseRent;
